module.exports = __webpack_public_path__ + "img/iconSystemMaterial.f4609b48.svg";